export default __webpack_public_path__ + "static/media/tile000.4826f104.png";